import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { logoutSuccess } from "../../redux/action";
import "./PaymentStatusPage.scss";

const PaymentStatusPage = () => {
  const { restaurant, id, table, status } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const isVoid = status === "Void" || status === "failed";

  function logout() {
    const allowedKeys = [
      "customer_portal_theme",
      "showBannerInLoginPage",
      "customer_portal_branch_id",
      "packageType",
    ];

    // 1. Clean SessionStorage (Yahan aapka theme data hai)
    Object.keys(sessionStorage).forEach((key) => {
      if (!allowedKeys.includes(key)) {
        sessionStorage.removeItem(key);
      }
    });

    // 2. Clean LocalStorage (Yahan aapke tokens/user data hain)
    Object.keys(localStorage).forEach((key) => {
      if (!allowedKeys.includes(key)) {
        localStorage.removeItem(key);
      }
    });
    dispatch(logoutSuccess());
    navigate(`/${restaurant}/${id}/${table}`);
  }

  useEffect(() => {
    // If it's a success, redirect. If it's void, let them stay and read.
    if (!isVoid) {
      const timer = setTimeout(() => logout(), 30000);
      return () => clearTimeout(timer);
    }
  }, [isVoid, navigate]);

  return (
    <div className={`status-container ${isVoid ? "void-bg" : "success-bg"}`}>
      <div className="status-card">
        <div className={`status-icon ${isVoid ? "error-icon" : "check-icon"}`}>
          {isVoid ? "!" : "✓"}
        </div>

        <h1>
          {isVoid ? "Transaction Canceled" : "Bill Generated Successful!"}
        </h1>

        <p>
          {isVoid
            ? `Your payment for Table ${table} was not completed or has been voided.`
            : ` We hope you enjoyed your meal. See you again soon!
               Thank you for dining with us ❤️.`}
        </p>

        {isVoid && (
          <div className="next-steps">
            <p>
              <strong>What should you do?</strong>
            </p>
            <ul>
              <li>Please try the payment again.</li>
              <li>Or, ask our staff for assistance.</li>
            </ul>
            <button className="retry-btn" onClick={() => navigate(-1)}>
              Go Back to Bill
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentStatusPage;
